// Keep in sync with transcription service
export enum AISocketEventEnum {
  JOIN_ROOM = 'joinRoom', // Sends necessary config data to backend.
  TRANSCRIPTION_DATA = 'transcriptionData', // Event fired on receiving transcriptionData
  CONNECT = 'connection', // Initial connect event
  INITIAL_CAPTURE_START = 'initialCaptureStart',
  CAPTURE_START = 'startCapture',
  CAPTURE_END = 'endCapture',
  CAPTURE_FULL_END = 'endFullCapture',
  SEND_VIDEO_DATA = 'videoData',
  SEND_AUDIO_DATA = 'audioData',
  END_TRANSCRIPTION_NO_SUBMIT = 'endTranscriptionNoSubmit',
  END_TRANSCRIPTION = 'endTranscription',
  FINAL_TRANSCRIPTION_DATA = 'finalTranscriptionData',
  VIDEO_UPLOADED_SUCCESS = 'VideoUploadFinished',
  TEMP_VIDEO_UPLOAD_FINISHED = 'tempVideoUploadFinished',
  ATTEMPT_VIDEO_DATA_RECEIVED = 'attemptVideoDataReceived',
  SUBMISSION_MARKED = 'submissionMarked',
  SOCKET_AUDIO_START = 'synthAudioStart',
  SOCKET_AUDIO_PARTIAL_COMPLETE = 'fillerComplete',
  SOCKET_AUDIO_WITH_TEXT = 'synthAudioChunk',
  SOCKET_AUDIO_COMPLETE = 'synthAudioComplete',
  VIDEO_INTERVIEW_QUESTION = 'videoChunk',
}

export const TIMEEOUT_FOR_USER_AUDIO_CHUNK = 3000;
export const SILENCE_THRESHOLD = 0.01; // adjust this value as needed

export const convertHexToRGBNumbers = (hex: string) => {
  hex = hex.replace(/^#/, '');

  // Parse the three components of the hex code
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  // Return the RGB string
  return `${r}, ${g}, ${b}`;
};

export enum HELPER_SPEECH_ENUM {
  GRACE_PERIOD = 'GRACE_PERIOD',
  WAIT_PERIOD = 'WAIT_PERIOD',
  MOVE_NEXT = 'MOVE_NEXT',
  INTERVIEW_START = 'INTERVIEW_START',
  INTERVIEW_RESTART = 'INTERVIEW_RESTART',
  INTERVIEW_END = 'INTERVIEW_END',
  CODING_NEXT = 'CODING_NEXT',
  MUTE = 'MUTE',
  CANDIDATE_INTERRUPTION = 'CANDIDATE_INTERRUPTION',
  CODE_SUBMISSION = 'CODE_SUBMISSION',
  LAST_FEW_SEC = 'LAST_FEW_SEC',
}

export enum BOT_SOCKET_EVENT_TYPE_ENUM {
  AUDIO_START = 'audioStart',
  AUDIO_END = 'audioEnd',
  PUSH_MESSAGE = 'pushMessage',
  AUDIO_RESUME = 'audioResume',
  AUDIO_PAUSE = 'audioPause',
  AUDIO_WITH_TEXT = 'audioWithText',
  AUDIO_CHANGED = 'audioChanged',
}
